import { images } from "../constants";

const home = {
        image: images.home,
        subtitle: "01 - 03 November, 2025 | Dublin, Ireland",
        title: "Inspiring {Keynotes} and Workshops",
        buttonText: "See Schedule",
        buttonLink: "ScheduleTab",
};

export default home;